var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.sub)?[_c('div',{staticClass:"yuyue-btn sub"})]:[(_vm.openid)?_c('div',{staticClass:"yuyue-btn",domProps:{"innerHTML":_vm._s(_vm.subscribeNode)}}):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }